module.exports = __webpack_public_path__ + "img/people-white.44867abc.svg";